
import posthog from 'posthog-js';

/**
 * PostHog Analytics Service
 * Connects to PostHog for advanced session tracking and event monitoring.
 * Features a fallback to a local proxy for reliability.
 */

// Generate or retrieve a persistent anonymous ID for this browser session fallback
const getAnonymousId = () => {
  let id = localStorage.getItem('hwb_anon_id');
  if (!id) {
    id = 'anon_' + Math.random().toString(36).substring(2, 15) + Math.random().toString(36).substring(2, 15);
    localStorage.setItem('hwb_anon_id', id);
  }
  return id;
};

export const trackEvent = async (eventName: string, properties: any = {}) => {
  const timestamp = new Date().toISOString();
  const anonymousId = getAnonymousId();
  
  // 1. Capture via official PostHog library (handles buffering and persistence)
  try {
    // PostHog automatically manages initialization state
    posthog.capture(eventName, {
      ...properties,
      $set: properties.email ? { email: properties.email } : undefined,
    });
    
    // If we have an email, identify the user in PostHog
    if (properties.email) {
      posthog.identify(properties.email);
    }
  } catch (e) {
    console.warn("PostHog capture failed:", e);
  }

  // 2. Secondary Tracking to local proxy for custom server-side side effects
  const payload = {
    event: eventName,
    anonymousId,
    timestamp,
    properties: {
      ...properties,
      url: window.location.href,
      screenSize: `${window.innerWidth}x${window.innerHeight}`,
      language: navigator.language
    }
  };

  try {
    const response = await fetch('/api/track', {
      method: 'POST',
      headers: {
        'Content-Type': 'application/json',
      },
      body: JSON.stringify(payload),
    });

    if (!response.ok) {
      console.warn('Backend tracking sync failed');
    }
  } catch (e) {
    // Fail silently in production for analytics calls
    console.debug("Analytics network error:", e);
  }
};
